module.exports = __webpack_public_path__ + "media/bell.083dd8f6.mp3";